import { render, staticRenderFns } from "./FooterText.vue?vue&type=template&id=d5b826b8"
import script from "./FooterText.vue?vue&type=script&lang=ts"
export * from "./FooterText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports